import { render, staticRenderFns } from "./nearbyCourses.vue?vue&type=template&id=1efaed1b"
import script from "./nearbyCourses.vue?vue&type=script&lang=js"
export * from "./nearbyCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports